/**
 * TanStack Query hooks for `google-ads-enhanced-conversions-server-side-hashed`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	googleAdsEnhancedConversionsServerSideHashedQueryKeys,
	type CreateGoogleAdsEnhancedConversionsServerSideHashedBody,
	type ListGoogleAdsEnhancedConversionsServerSideHashedResponse,
	type GoogleAdsEnhancedConversionsServerSideHashedRow,
} from "./api";

export function useGoogleAdsEnhancedConversionsServerSideHashedList(): UseQueryResult<ListGoogleAdsEnhancedConversionsServerSideHashedResponse, Error> {
	return useQuery({
		queryKey: googleAdsEnhancedConversionsServerSideHashedQueryKeys.list(),
		queryFn: list,
	});
}

export function useGoogleAdsEnhancedConversionsServerSideHashedCreate(): UseMutationResult<GoogleAdsEnhancedConversionsServerSideHashedRow, Error, CreateGoogleAdsEnhancedConversionsServerSideHashedBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsEnhancedConversionsServerSideHashedQueryKeys.all });
		},
	});
}

export function useGoogleAdsEnhancedConversionsServerSideHashedDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsEnhancedConversionsServerSideHashedQueryKeys.all });
		},
	});
}
